import { FC } from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { genericTexts } from '@utils/translations/en';

interface SidepanelFooterProps {
  onSave: () => void;
  onCancel: () => void;
  isSaveDisabled?: boolean;
}

/**
 * Sticky footer bar rendered as the last flex child of SidepanelLayout.
 * Stays pinned to the bottom without any fixed/absolute positioning.
 */
const SidepanelFooter: FC<SidepanelFooterProps> = ({
  onSave,
  onCancel,
  isSaveDisabled = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: '1rem',
        mt: 'auto',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        gap: 2,
        borderTop: '1px solid #E8EAEB',
      }}
    >
      <Button
        variant="contained"
        disabled={isSaveDisabled}
        onClick={onSave}
        sx={{
          background: theme.palette.primary.main,
          color: '#F6F8F9',
          borderRadius: '100px',
          textTransform: 'none',
          px: '1.5rem',
          '&:hover': { background: theme.palette.primary.main },
        }}
      >
        {genericTexts.Save}
      </Button>
      <Button
        variant="outlined"
        onClick={onCancel}
        sx={{
          borderRadius: '100px',
          color: '#6C6C6C',
          borderColor: theme.palette.secondary.main,
          textTransform: 'none',
          '&:hover': { borderColor: theme.palette.secondary.main },
        }}
      >
        {genericTexts.Cancel}
      </Button>
    </Box>
  );
};

export default SidepanelFooter;
